import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Card,
  CardContent,
  Avatar,
  Chip,
} from '@mui/material';
import {
  Gavel as CouncilIcon,
  Person as PersonIcon,
  Description as DocumentIcon,
  Event as EventIcon,
} from '@mui/icons-material';

const DataGovernanceCouncil: React.FC = () => {
  const councilMembers = [
    { name: 'Russell Riehl', role: 'Chief Data Officer', department: 'Data Strategy' },
    { name: 'Council Member', role: 'Data Steward Lead', department: 'Operations' },
    { name: 'Council Member', role: 'Compliance Officer', department: 'Legal' },
    { name: 'Council Member', role: 'IT Director', department: 'Technology' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <CouncilIcon sx={{ fontSize: 40 }} />
          Data Governance Council
        </Typography>
        <Typography variant="body1" color="text.secondary">
          DHS-aligned governance structure and leadership
        </Typography>
      </Box>

      {/* Council Charter */}
      <Paper sx={{ p: 3, mb: 3, background: 'linear-gradient(135deg, #0055AA 0%, #0066CC 100%)', color: 'white' }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'white' }}>
          📜 Council Charter
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'white' }}>
          The Data Governance Council provides strategic oversight and decision-making authority
          for the organization's data governance program, aligned with DHS Data Governance Council Charter
          and Federal Data Strategy guidelines.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip label="Data Integrity" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
          <Chip label="Quality Assurance" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
          <Chip label="Compliance" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
          <Chip label="Collaboration" sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white' }} />
        </Box>
      </Paper>

      {/* Council Members */}
      <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
        Council Members
      </Typography>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {councilMembers.map((member, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    margin: '0 auto 16px',
                    bgcolor: 'primary.main',
                    fontSize: 32,
                  }}
                >
                  <PersonIcon fontSize="large" />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {member.name}
                </Typography>
                <Typography variant="body2" color="primary" sx={{ mb: 0.5 }}>
                  {member.role}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {member.department}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Council Activities */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <EventIcon sx={{ color: 'primary.main', mr: 1 }} />
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600 }}>
                Recent Meetings
              </Typography>
            </Box>
            <Box sx={{ color: 'text.secondary' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Q4 2025 Governance Review - October 15, 2025
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Policy Approval Session - October 1, 2025
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                • Data Quality Initiative Kickoff - September 20, 2025
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <DocumentIcon sx={{ color: 'primary.main', mr: 1 }} />
              <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 600 }}>
                Key Documents
              </Typography>
            </Box>
            <Box sx={{ color: 'text.secondary' }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Council Charter (DHS-aligned)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Roles & Responsibilities Matrix
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Decision-Making Framework
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                → Meeting Minutes Archive
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {/* Coming Soon */}
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 4,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)',
              border: '2px dashed #003366',
            }}
          >
            <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
              🚧 Full Council Portal Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Features will include: Meeting scheduling, Document management, Decision tracking,
              Member directory, Voting system, and more.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DataGovernanceCouncil;
